module.exports = __webpack_public_path__ + "img/result_about.2f74a0f1.png";